import * as _ from "underscore";

export function componentArrayHasChanges(original, modified): boolean {
    let hasChanges = false;
    modified.forEach(modifiedComponent => {
      let originalComponent = original.find(originalComponent => originalComponent.componentType === modifiedComponent.componentType);
  
      let equal = _.isEqual(originalComponent, modifiedComponent);
      if (equal) {
        return;
      } else {
        hasChanges = true;
      }
    });
    return hasChanges;
  }